<template>
  <div>
      <el-row class="mt-2">
          <b class="font_extralarge">依据用户名和学习班进行导出</b>      
          <p class="p3">导出学员参与该学习班的总学时以及详细</p>  
      </el-row>
      <!-- 第二部分，上传 -->
      <el-row class="mt-2">
          <b class="font_base">1. 选择用户</b>        
      </el-row>

      <el-row class="mt-2">
        <PersonSelect @onValueChanged="onPersonChanged"></PersonSelect>
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入内容"
          class="mt-1"
          v-model="personsJson">
        </el-input>
        <el-button class="mt-1" @click="confirmUid" :loading="loading">导入</el-button>
      </el-row>

      <el-row>
        <b class="font_base">已选择的学员：</b>                
      </el-row>

      <el-row class="select_user_row">
        <template v-for="(item,index) in selectUsers">
          <el-row class="mt-1" :key="item.label">              
            <el-col :span="12">
                <p class="p3">{{item.label}}</p>
            </el-col>
            <el-col :span="3">
                <p class="p3 mt-0">{{item.value}}</p>
            </el-col>
            <el-col :span="3">
              <el-link type="warning" @click="onRemoveSelectUser(index)">移除</el-link>
            </el-col>
          </el-row>  
        </template>      
      </el-row>

      <el-row class="mt-2">
          <b class="font_base">2. 选择学习班</b>        
      </el-row>

      <el-row class="mt-2">
        <StudyClassSelect @onValueChanged="onSCValChanged"></StudyClassSelect>
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入内容"
          class="mt-1"
          v-model="studyclassJson">
        </el-input>
        <el-button class="mt-1" @click="confirmSCid" :loading="loading">导入</el-button>
      </el-row>

      <el-row class="select_user_row">
        <template v-for="(item,index) in studyclasses">
          <el-row class="mt-1" :key="item.title">              
            <el-col :span="12">
                <p class="p3">{{item.title}}</p>
            </el-col>
            <el-col :span="3">
                <p class="p3 mt-0">{{item.value}}</p>
            </el-col>
            <el-col :span="3">
              <el-link type="warning" @click="onRemoveSCVal(index)">移除</el-link>
            </el-col>
          </el-row>  
        </template>      
      </el-row>


      <el-row>
          <el-button style="margin-top: 12px;" type="primary" @click="publish" :loading="loading">确认</el-button>
          <el-button style="margin-top: 12px;"  @click="publishJG" :loading="loading">导出局机关数据</el-button>
      </el-row>
  </div>
</template>

<script>
import { PersonSelect,StudyClassSelect } from "@/views/components/select"
import { exportByUserAndStudyClass,importUidsApi,importScidsApi,exportByUserAndStudyClassDangxiao } from "@/api/module/export/export"

export default {

  name : 'ExportByUserAndStudyClass',

  components:{
    PersonSelect,StudyClassSelect
  },

  data(){
    return {
      loading : false,
      selectUsers : [],
      studyclasses:[],
      personsJson : null,
      studyclassJson : null,
      jsondata : null,
      retired : false

    }
  },
  methods:{
    init(){
    },

    onPersonChanged(val,item){
      this.selectUsers.push(item);
    },

    onSCValChanged(val,item){
      console.log("onSCValChanged",val,item)
      this.studyclasses.push(item);
    },

    onRemoveSelectUser(index){
      this.selectUsers.splice(index,1)
    },

    onRemoveSCVal(index){
      this.studyclasses.splice(index,1)

    },

    publish(){

      if(this.loading){
        return;
      }

      

      if(!this.selectUsers || this.selectUsers.length == 0){
        ElMessage.error("未获得用户信息")
        return;
      }

      if(!this.studyclasses || this.studyclasses.length == 0){
        ElMessage.error("未获得学习班信息")
        return;
      }

      this.loading = true;

      // localStorage.setItem("export_area__users_8",JSON.stringify(this.selectUsers))
      // localStorage.setItem("export_area__studyclasses_8",JSON.stringify(this.studyclasses))


      console.log("this.selectUsers",this.selectUsers)

      let uids = new Array();
      for(let i = 0; i < this.selectUsers.length; i++){
        uids.push(this.selectUsers[i].id);
      }

      let studyClassIds = new Array();
      for(let i = 0; i < this.studyclasses.length; i++){
        studyClassIds.push(this.studyclasses[i].id);
      }


      exportByUserAndStudyClass(uids,studyClassIds)
        .then((res)=>{
          if(res.data.size > 0){
                let filename = "data.xls";
                let data = res.data;

                console.log("res.data",data.length)

                let url = window.URL.createObjectURL(new Blob([data]));
                let link = document.createElement("a");
                link.style.display = "none";
                link.href = url;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click()    
            }
            else {
                ElMessage.error("导出错误");
            }
        })
        .finally(()=>{
          this.loading = false;
        })
    },

    confirmUid(){

      if(!this.personsJson){
        return;
      }

      let pj = JSON.parse(this.personsJson);

      importUidsApi(pj)
        .then((r)=>{
          console.log("personsJson",r)
          for(let i = 0; i < r.length; i++){
            let item = {
              label : r[i].name + " - " + r[i].unitTitle,
              value : r[i].id,
              id : r[i].id
            }

            this.selectUsers.push(item);
          }
        })
    },

    confirmSCid(){

      if(!this.studyclassJson){
        return;
      }

      let pj = JSON.parse(this.studyclassJson);

      importScidsApi(pj)
        .then((r)=>{
          for(let i = 0; i < r.length; i++){
            let item = {
              title : r[i].title,
              value : r[i].id,
              id : r[i].id
            }

            this.studyclasses.push(item);
          }
        })



      importScidsApi
    },



    publishJG(){
      
      if(this.loading){
        return;
      }

      if(!this.selectUsers || this.selectUsers.length == 0){
        ElMessage.error("未获得用户信息")
        return;
      }

      this.loading = true;

      console.log("this.selectUsers",this.selectUsers)

      let uids = new Array();
      for(let i = 0; i < this.selectUsers.length; i++){
        uids.push(this.selectUsers[i].id);
      }


      exportByUserAndStudyClassDangxiao(uids)
        .then((res)=>{
          if(res.data.size > 0){
                let filename = "data.xls";
                let data = res.data;

                console.log("res.data",data.length)

                let url = window.URL.createObjectURL(new Blob([data]));
                let link = document.createElement("a");
                link.style.display = "none";
                link.href = url;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click()    
            }
            else {
                ElMessage.error("导出错误");
            }
        })
        .finally(()=>{
          this.loading = false;
        })

    }


  },

  mounted(){


  },

  created() {

  }



}
</script>
<style scoped lang="scss">
.title {
  font-size: 14px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}

.select_user_row{
  margin-top: 0px;
  margin-bottom: 0px;

  max-height: 300px;
  overflow-y: auto;

  p {
    margin-top: 2px;
    margin-bottom: 2px;
  }
}
</style>